@if (isAudio) {
    <audio controls [src]="attachment.url"></audio>
} @else {
    <div class="file-preview" [ngClass]="{ 'h-100': isOnlyPreviewIcon }">
        <div
            class="file-icon"
            [ngClass]="{ pointer: !isPreventPreviewInModal, 'h-100': isOnlyPreviewIcon }"
            (click)="openDocumentViewerModal($event)">
            @if (isImage) {
                <div class="text-center">
                    @if (attachment.isExpired) {
                        <img
                            class="image-expired"
                            [alt]="'Broken image' | translate"
                            [src]="'./sb-tools/theme/images/broken-attachment.png'" />
                    } @else {
                        <img [src]="attachment.previewUrl || attachment.url" [alt]="'Image attachment' | translate" />
                    }
                </div>
            } @else {
                <sb-inline-svg class="icon" [url]="'./sb-tools/theme/images/file-types/file-' + fileType + '.svg'">
                </sb-inline-svg>
            }
        </div>

        @if (!isOnlyPreviewIcon) {
            <div
                class="file-name float-start"
                [ngClass]="{ 'color-blue': !isPreventPreviewInModal }"
                tooltip="{{ isFileNameWithTooltip ? fileName : '' }}">
                <small>
                    @if (isPreventPreviewInModal) {
                        <span>{{ fileName }}</span>
                    } @else {
                        <a class="pointer" (click)="openDocumentViewerModal($event)">
                            {{ fileName }}
                        </a>
                    }
                </small>
            </div>
            <div class="file-controls float-end">
                @if (isPrintingAvailable) {
                    <button
                        type="button"
                        (click)="$event.stopPropagation(); printService.printAttachment(attachment.url)"
                        [attr.aria-label]="'Print file' | translate"
                        class="btn btn-icon btn-transparent btn-xs"
                        tooltip="{{ 'Print' | translate }}">
                        <sb-inline-svg
                            class="icon pointer"
                            [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/print.svg'">
                        </sb-inline-svg>
                    </button>
                }

                @if (canBeRemoved) {
                    <button
                        type="button"
                        (click)="removeCurrentAttachment(attachment)"
                        [attr.aria-label]="'Delete file' | translate"
                        class="btn btn-icon btn-transparent btn-xs"
                        tooltip="{{ 'Delete' | translate }}">
                        <sb-inline-svg
                            class="icon pointer"
                            [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                        </sb-inline-svg>
                    </button>
                }

                <a
                    class="btn btn-icon btn-transparent btn-xs link"
                    type="button"
                    tooltip="{{ 'Download' | translate }}"
                    [attr.aria-label]="'Download file' | translate"
                    [href]="attachment.url"
                    target="_blank"
                    download="{{ fileName }}">
                    <sb-inline-svg
                        class="icon"
                        [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Download icon.svg'"
                        (click)="$event.stopPropagation()">
                    </sb-inline-svg>
                </a>
            </div>
        }
    </div>
}
